(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsTypesDetailController', ScriptsTypesDetailController);

    ScriptsTypesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity'];

    function ScriptsTypesDetailController($scope, $rootScope, $stateParams, entity) {
        var vm = this;
        vm.scriptsTypes = entity;

        var unsubscribe = $rootScope.$on('jotApp:scriptsTypesUpdate', function(event, result) {
            vm.scriptsTypes = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
